import { useState } from "react";
import { CryptoPayCard } from "@/features/billing/CryptoPayCard";
import { Button, StatusPill } from "@/shared/ui";
import { useOrderStatus } from "@/shared/api/hooks";
import { useI18n } from "@/shared/i18n";
import type { OrderStatusResponse } from "@/shared/api/schemas";
import { orderTone, orderLabelKey } from "@/features/billing/status";

/** One history row; fetches live status for the tracked order id. */
export function OrderRow({ order }: { order: OrderStatusResponse }) {
  const [resume, setResume] = useState(false);
  const q = useOrderStatus(order.out_trade_no);
  const { t } = useI18n();
  const current = q.data ?? order;
  const status = current.status;
  return (
    <>
    <div className="acc-row">
      <div className="acc-row__main">
        <span className="acc-row__title">{order.package}</span>
        <span className="acc-row__meta">{order.out_trade_no}</span>
      </div>
      <div className="acc-row__right">
        {current.payment && status === "created" && <Button variant="ghost" onClick={() => setResume(s => !s)}>{t("Continue payment")}</Button>}
        {status === "created" && current.pay_url && (
          <a href={current.pay_url} target="_blank" rel="noopener noreferrer">{t("Continue payment")}</a>
        )}
        {q.data && <span>{t("{n} words", { n: q.data.tokens.toLocaleString("en-US") })}</span>}
        {status ? (
          <StatusPill tone={orderTone(status)} dot>
            {t(orderLabelKey(status))}
          </StatusPill>
        ) : (
          <StatusPill tone="pending">{t("Checking…")}</StatusPill>
        )}
      </div>
    </div>
    {resume && current.payment && <CryptoPayCard order={current.payment} onPaid={() => { void q.refetch(); }} onClose={() => setResume(false)} />}
    </>
  );
}
